






























































import { Prop, Component, Vue } from "vue-property-decorator";
import CalendarMonthView from "./private/CalendarMonthView.vue";
import CalendarWeekView from "./private/CalendarWeekView.vue";
import CalendarDayView from "./private/CalendarDayView.vue";
import CalendarYearView from "./private/CalendarYearView.vue";
import { ViewType, trunc } from "../date-picker/private/Utils";

@Component({
    components: {
        CalendarMonthView,
        CalendarWeekView,
        CalendarDayView,
        CalendarYearView,
    },
})
export default class AbcCalendar extends Vue {
    @Prop() value!: Date | null;
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    @Prop() items!: any[];
    @Prop({ required: true }) dateField!: string;
    @Prop({ default: "month" }) view!: ViewType;
    @Prop({ type: Boolean }) isMondayFirst!: boolean;

    private range: Date[] = [];

    private get curDate() {
        return this.value;
    }

    private set curDate(val: Date | null) {
        if(val){
            val = trunc(val)
        }
        this.ref = val;
        this.$emit("input", val);
        if(this.curView !== "day"){
            this.curView = "day";
        }
    }

    private get curView() {
        return this.view ;
    }

    private set curView(val: ViewType) {
        this.$emit("update:view", val);
    }

    private changeView(val: ViewType) {
        this.$emit("update:view", val);
    }

    private ref: Date | null = null;

    private get refDate(): Date {
        return this.ref || this.curDate || new Date();
    }

    private onNewRange(range: Date[]){
        this.$emit('new-range', range);
        this.range = range;
    }

    private navigate(num = 1) {
        let month = this.refDate.getMonth();
        let year = this.refDate.getFullYear();
        let date = this.refDate.getDate();

        if (this.curView === "month") {
            month += num;
        } else if (this.curView === "week" || this.curView === "day") {
            date += num;
        } else if(this.curView === "year"){
            year += num;
        }

        this.ref = new Date(year, month, date);
    }

    private get curItems() {
        if(this.range.length === 0){
            return [];
        }
        return this.items.filter((i) => {
            return (trunc(i[this.dateField]).getTime() >= this.range[0].getTime() && trunc(i[this.dateField]).getTime() <= this.range[1].getTime());
        });
    }

    private get objItems() {
        /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
        const obj: { [dt: number]: any[] } = {};
        this.curItems.forEach((i) => {
            let curObj = obj[trunc(i[this.dateField]).getTime()];
            if (!curObj) {
                curObj = [];
            }
            curObj.push(i);
            curObj.sort((a,b) => a[this.dateField] - b[this.dateField])
            obj[trunc(i[this.dateField]).getTime()] = curObj;
        });
        return obj;
    }

    private onCellHeightUpdate(height: number){
        this.$emit('cell-height-updated', height);
    }
}
